export const numberWithSpaces = (number) =>
	number >= 10000 ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : number.toString();
